import { CommodityFilterInput, CommodityStats } from '@bechtel/types';
import { useLazyQuery, QueryTuple } from '@apollo/client';
import { GET_COMMODITY_STATS, GET_COMMODITY_STATS_CLAIMED_UNASSIGNED_FWE,GET_COMMODITY_STATS_PRIORITY } from '@bechtel/client-gql';

export function useCommodityStatsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_STATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
export function useCommodityStatsPriorityQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_STATS_PRIORITY,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}

export function useCommodityStatsClaimedAndUnassignedFWEQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_STATS_CLAIMED_UNASSIGNED_FWE,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
